(function () {
  const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
  const DISCOUNT = "S45QGJJB8ESA";

  function money(cents) {
    const amount = Number(cents) / 100;
    return Number.isInteger(amount) ? `$${amount}` : `$${amount.toFixed(2)}`;
  }

  function pairTotal(unit, quantity) {
    const full = Number(unit) * quantity;
    return quantity >= 2 ? Math.round(full * 0.9) : full;
  }

  function init(root) {
    if (!root || root.dataset.ready === "true") return;
    const productNode = root.querySelector("[data-reasons-product]");
    if (!productNode) return;
    let product;
    try {
      product = JSON.parse(productNode.textContent);
    } catch (error) {
      console.error(error);
      return;
    }
    if (!product || !product.variants || !product.variants.length) return;
    root.dataset.ready = "true";

    const landing = root.dataset.landing || "teen-phone";
    const menu = root.querySelector("[data-reasons-menu]");
    const photo = root.querySelector("[data-reasons-photo]");
    const colorLabel = root.querySelector("[data-reasons-color]");
    const prices = () => root.querySelectorAll("[data-reasons-price]");
    const onePrice = root.querySelector("[data-reasons-one]");
    const twoPrice = root.querySelector("[data-reasons-two]");
    const total = root.querySelector("[data-reasons-total]");
    const ship = root.querySelector("[data-reasons-ship]");
    const carts = () => root.querySelectorAll("[data-reasons-cart]");
    const qtyButtons = () => root.querySelectorAll("[data-reasons-qty]");
    let quantity = 1;
    let variantId = menu && menu.dataset.variantId;

    function current() {
      return product.variants.find((variant) => String(variant.id) === String(variantId)) || product.variants[0];
    }

    function cartHref(variant) {
      const url = new URL(`${window.location.origin}/cart/${variant.id}:${quantity}`);
      if (quantity >= 2) url.searchParams.set("discount", DISCOUNT);
      url.searchParams.set("attributes[landing_page_variant]", landing);
      const params = new URLSearchParams(window.location.search);
      UTM_KEYS.forEach((key) => {
        const value = params.get(key);
        if (value) url.searchParams.set(`attributes[${key}]`, value);
      });
      return url.pathname + url.search;
    }

    function paint() {
      const variant = current();
      const option = menu && menu.querySelector(`[data-reasons-option][data-id="${variant.id}"]`);
      const label = option ? option.dataset.label : variant.title;
      const image = option && option.dataset.image;
      if (colorLabel) colorLabel.textContent = label;
      if (photo && image) photo.src = image;
      if (menu && option) {
        const thumb = menu.querySelector("[data-reasons-thumb]");
        const menuLabel = menu.querySelector("[data-reasons-menu-label]");
        if (thumb) thumb.src = option.dataset.image;
        if (menuLabel) menuLabel.textContent = option.dataset.label;
        menu.querySelectorAll("[data-reasons-option]").forEach((button) => {
          const selected = button.dataset.id === String(variant.id);
          button.setAttribute("aria-selected", selected ? "true" : "false");
          const mark = button.querySelector(".vmenu__mark");
          if (mark) mark.textContent = selected ? "✓" : "";
        });
      }
      prices().forEach((node) => {
        node.textContent = money(variant.price);
      });
      if (onePrice) onePrice.textContent = money(variant.price);
      if (twoPrice) twoPrice.textContent = money(pairTotal(variant.price, 2));
      const totalLabel = `Add to cart — ${money(pairTotal(variant.price, quantity))}`;
      if (total) total.textContent = totalLabel;
      root.querySelectorAll("[data-reasons-dock] b").forEach((node) => {
        node.textContent = totalLabel;
      });
      if (ship) {
        if (quantity >= 2) ship.textContent = "10% off and free shipping on this order.";
        else if (Number(variant.price) >= 5000) ship.textContent = "Free shipping on this order.";
        else ship.textContent = "Free shipping on orders over $50.";
      }
      carts().forEach((link) => {
        if (variant.available) {
          link.removeAttribute("aria-disabled");
          link.href = cartHref(variant);
        } else {
          link.setAttribute("aria-disabled", "true");
          link.removeAttribute("href");
        }
      });
      qtyButtons().forEach((button) => {
        const on = Number(button.dataset.reasonsQty) === quantity;
        button.classList.toggle("on", on);
        button.setAttribute("aria-pressed", on ? "true" : "false");
      });
    }

    if (menu) {
      const toggle = menu.querySelector("[data-reasons-toggle]");
      const list = menu.querySelector(".vmenu__list");
      const setOpen = (open) => {
        menu.classList.toggle("is-open", open);
        if (toggle) toggle.setAttribute("aria-expanded", open ? "true" : "false");
        if (list) list.hidden = !open;
      };
      if (toggle) toggle.addEventListener("click", () => setOpen(!menu.classList.contains("is-open")));
      menu.addEventListener("click", (event) => {
        const option = event.target.closest("[data-reasons-option]");
        if (!option || option.disabled) return;
        variantId = option.dataset.id;
        setOpen(false);
        paint();
      });
      document.addEventListener("mousedown", (event) => {
        if (!menu.contains(event.target)) setOpen(false);
      });
      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") setOpen(false);
      });
    }
    qtyButtons().forEach((button) => {
      button.addEventListener("click", () => {
        quantity = Number(button.dataset.reasonsQty) || 1;
        paint();
      });
    });
    paint();

    if (window.dataLayer && root.dataset.viewFired !== "true") {
      root.dataset.viewFired = "true";
      const variant = current();
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "view_item",
        landing_page_variant: landing,
        ecommerce: {
          currency: "USD",
          value: Number(variant.price) / 100,
          items: [{
            item_id: String(variant.id),
            item_name: product.title,
            item_brand: "Mindsight",
            item_variant: variant.title,
            price: Number(variant.price) / 100,
            quantity: 1,
          }],
        },
      });
    }

    carts().forEach((link) => {
      link.addEventListener("click", () => {
        const variant = current();
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: "add_to_cart",
          landing_page_variant: landing,
          ecommerce: {
            currency: "USD",
            value: pairTotal(variant.price, quantity) / 100,
            items: [{
              item_id: String(variant.id),
              item_name: product.title,
              item_brand: "Mindsight",
              item_variant: variant.title,
              price: Number(variant.price) / 100,
              quantity: quantity,
            }],
          },
        });
      });
    });

    const buy = root.querySelector("#buy");
    const dock = root.querySelector("[data-reasons-dock]");
    if (dock) {
      const hero = root.querySelector(".reasons__hero .reasons__btn");
      let heroGone = false;
      let buySeen = false;
      const updateDock = () => {
        dock.classList.toggle("is-hidden", !(heroGone && !buySeen));
      };
      if ("IntersectionObserver" in window) {
        if (hero) {
          new IntersectionObserver(([entry]) => {
            heroGone = !entry.isIntersecting;
            updateDock();
          }).observe(hero);
        }
        if (buy) {
          new IntersectionObserver(([entry]) => {
            buySeen = entry.isIntersecting;
            updateDock();
          }, { threshold: 0.2 }).observe(buy);
        }
      }
      const onScroll = () => {
        if ("IntersectionObserver" in window) return;
        const y = window.scrollY || document.documentElement.scrollTop || 0;
        const rect = buy ? buy.getBoundingClientRect() : null;
        const visible = rect && rect.top < window.innerHeight * 0.7 && rect.bottom > 80;
        dock.classList.toggle("is-hidden", !(y > 280 && !visible));
      };
      document.addEventListener("scroll", onScroll, { passive: true, capture: true });
      updateDock();
    }

    root.querySelectorAll("[data-reasons-faq]").forEach((item) => {
      const button = item.querySelector("button");
      const answer = item.querySelector("p");
      if (!button || !answer) return;
      button.addEventListener("click", () => {
        const open = button.getAttribute("aria-expanded") === "true";
        root.querySelectorAll("[data-reasons-faq]").forEach((other) => {
          const otherButton = other.querySelector("button");
          const otherAnswer = other.querySelector("p");
          if (!otherButton || !otherAnswer) return;
          otherButton.setAttribute("aria-expanded", "false");
          otherButton.querySelector("i").textContent = "+";
          otherAnswer.hidden = true;
        });
        if (!open) {
          button.setAttribute("aria-expanded", "true");
          button.querySelector("i").textContent = "−";
          answer.hidden = false;
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll("[data-reasons]").forEach(init);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", (event) => {
    const root = event.target && event.target.querySelector("[data-reasons]");
    if (root) {
      delete root.dataset.ready;
      init(root);
    }
  });
})();
